export const PASSWORD_RESTRICTIONS = {
  MIN_LENGTH: 8,
  MAX_LENGTH: 255,
};

export const AFTER_EMAIL_VERIFICATION_REDIRECT_API_URL = 'setEmailVerified';//  goes after 'http.../api/'
